import { render, staticRenderFns } from "./OrganisationManagement.vue?vue&type=template&id=57d6dcfc&"
import script from "./OrganisationManagement.vue?vue&type=script&lang=ts&"
export * from "./OrganisationManagement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports